import { render, staticRenderFns } from "./login-footer.vue?vue&type=template&id=a6f9cf18"
var script = {}
import style0 from "./login-footer.vue?vue&type=style&index=0&id=a6f9cf18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports